import { render } from "./berita_brida.vue?vue&type=template&id=49fedce9"
import script from "./berita_brida.vue?vue&type=script&lang=js"
export * from "./berita_brida.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dinaskominfo/Documents/Project/Vue/Erida/eridaApp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QImg,QCardSection,QItem,QItemSection,QIcon,QItemLabel,QSeparator});
